exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list li[_v-7e56f776]{padding:12px 15px;border-bottom:1px solid #292c33;cursor:pointer;-webkit-transition:background-color .1s;transition:background-color .1s}.list li[_v-7e56f776]:hover{background-color:hsla(0,0%,100%,.03)}.list li.active[_v-7e56f776]{background-color:hsla(0,0%,100%,.1)}.list .avatar[_v-7e56f776],.list .name[_v-7e56f776]{vertical-align:middle}.list .avatar[_v-7e56f776]{border-radius:2px}.list .name[_v-7e56f776]{display:inline-block;margin:0 0 0 15px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-7e56f776&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/list.vue
 ** module id = 314
 ** module chunks = 0
 **/